import { render, staticRenderFns } from "./ResultDetails.vue?vue&type=template&id=364a9b44&scoped=true&"
import script from "./ResultDetails.vue?vue&type=script&lang=js&"
export * from "./ResultDetails.vue?vue&type=script&lang=js&"
import style0 from "./ResultDetails.vue?vue&type=style&index=0&id=364a9b44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a9b44",
  null
  
)

export default component.exports